import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
import { getBannersVisibility } from '.';
import { IS_DEBUG_MODE, SHOULD_DISABLE } from '~/plugins/adfox';
export default defineComponent({
    name: 'RotatingBanner',
    props: {
        config: {
            required: true,
            type: Object,
        },
    },
    emits: ['complete'],
    setup(_, { emit }) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const shouldRender = computed(() => {
            return !SHOULD_DISABLE && (process.env.NODE_ENV !== 'development' || IS_DEBUG_MODE);
        });
        /**
         * Ротация баннеров
         * adfox - 50%, обменки - 50% (Сми 2 - 70%, инфокс - 20%, спэроу - 10%)
         */
        const bannersVisibility = getBannersVisibility({
            adfox: 50,
            infox: 10,
            smi2: 35,
            sparrow: 5,
        });
        function onComplete({ error = {}, state }) {
            emit('complete', { error, state });
        }
        return {
            css,
            onComplete,
            shouldRender,
            bannersVisibility,
        };
    },
});
